import React, { useEffect, useRef, useState } from 'react';

import Appearance from 'styles/Appearance.js';
import TextField from 'views/TextField.js';
import Utils from 'files/Utils.js';
import Views from 'views/Main.js';

const ListField = ({ containerStyle, deselect, icon, insetLabel, items = [], minimal, onAddNew, onChange, onRenderResult, prependComponent, preserveResult, style, value }) => {

    const [expanded, setExpanded] = useState(false);
    const [selected, setSelected] = useState(value);

    const onSelectItem = item => {

        setExpanded(false);
        let next = selected && selected.id === item.id ? null : item;
        if(deselect === false && next === null) {
            return;
        }
        setSelected(preserveResult === false ? null : next);
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const onToggleMenuState = () => {
        setExpanded(val => !val);
    }

    const getAccessoryButton = () => {
        if(typeof(onAddNew) === 'function') {
            return (
                <img
                className={'text-button'}
                src={'images/new-button-clear-small.png'}
                onClick={onAddNew}
                style={{
                    width: 25,
                    height: 25,
                    minWidth: 25,
                    minHeight: 25,
                    borderRadius: 12.5,
                    overflow: 'hidden',
                    objectFit: 'contain',
                    marginLeft: 12,
                    backgroundColor: Appearance.colors.primary()
                }} />
            )
        }
        return null;
    }

    const getAccessoryIcon = item => {
        if(selected && selected.id === item.id) {
            return (
                <img
                src={'images/checkmark-green-small.png'}
                style={{
                    width: 15,
                    height: 15,
                    objectFit: 'contain'
                }} />
            )
        }
        if(item.available === false) {
            return (
                <img
                src={'images/warning-icon-yellow.png'}
                style={{
                    width: 15,
                    height: 15,
                    objectFit: 'contain'
                }} />
            )
        }
        return (
            <img
            src={'images/next-arrow-light-grey-small.png'}
            style={{
                width: 12,
                height: 12,
                objectFit: 'contain'
            }} />
        )
    }

    const getItems = () => {
        if(expanded === false) {
            return null;
        }
        return (
            <div style={{
                ...Views.floating(),
                ...Utils.isMobile() === true && {
                    top: Views.floating().top + 10
                }
            }}>
                {items.filter(item => {
                    return item.visible !== false;
                }).map((item, index, items) => {
                    let nodes = typeof(onRenderResult) === 'function' ? onRenderResult(item, index, items) : null;
                    return (
                        <div
                        key={index}
                        className={`view-entry ${window.theme}`}
                        onClick={onSelectItem.bind(this, item)}
                        style={{
                            alignItems: 'center',
                            borderBottom: index !== items.length - 1 ? `1px solid ${Appearance.colors.divider()}` : null,
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            padding: '8px 12px 8px 12px',
                            width: '100%'
                        }}>
                            {nodes || (
                                <span style={{
                                    ...Appearance.textStyles.key(),
                                    minWidth: 0,
                                    ...Utils.isMobile() === true && {
                                        fontSize: 14
                                    }
                                }}>{item.title}</span>
                            )}
                            {getAccessoryIcon(item)}
                        </div>
                    )
                })}
            </div>
        )
    }

    useEffect(() => {
        setSelected(value);
    }, [value]);

    return (
        <div style={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            position: 'relative',
            textAlign: 'left',
            width: '100%',
            ...style,
            height: 'auto'
        }}>
            <TextField
            containerStyle={containerStyle}
            focused={expanded}
            icon={icon}
            insetLabel={insetLabel}
            minimal={minimal}
            onClick={onToggleMenuState}
            prependComponent={prependComponent}
            value={selected ? selected.title : 'Select an item from the list'}
            appendComponent={(
                <img
                className={'cursor-pointer'}
                onClick={onToggleMenuState}
                src={expanded ? 'images/up-arrow-grey-small.png' : 'images/down-arrow-grey-small.png'}
                style={{
                    width: 12,
                    height: 12,
                    objectFit: 'contain'
                }} />
            )}/>
            {getAccessoryButton()}
            {getItems()}
        </div>
    )
}

export default ListField;
